import { StudyTranslationLanguage } from "healthex-common/study.dtos";
import { willNeverHappen } from "healthex-common/utils";
export function languageDescription(language) {
    switch (language) {
        case StudyTranslationLanguage.en:
            return "English";
        case StudyTranslationLanguage.es:
            return "Spanish";
    }
    return willNeverHappen(language);
}
